import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import { wlsly } from 'helpers/wlsly'

const initialState = {
  value: (wlsly()?.initialState as Record<string, unknown> | null) ?? null,
}

export const initialStateSlice = createSlice({
  name: 'initialState',
  initialState,
  reducers: {
    setInitialState: (
      state,
      action: PayloadAction<Record<string, unknown>>,
    ) => {
      state.value = action.payload
    },
    clearInitialState: (state) => {
      state.value = null
    },
  },
  selectors: {
    selectInitialState: (state) => state.value,
  },
})
